// Shared list of timezone choices surfaced anywhere a user can change
// their preferred display zone (Settings page, billing sheet header,
// any future inline switcher). Kept as data so all switchers stay in
// sync — adding a zone here adds it everywhere.
import { TZ_AUTO, TZ_UTC } from "@/hooks/useTimezonePref";

export interface TzOption {
  value: string;
  label: string;
}

export interface TzOptionGroup {
  label: string;
  options: TzOption[];
}

/** Build the option groups. The "Automatic" label for TZ_AUTO needs
 * the resolved browser zone, so this is a function not a constant. */
export function buildTzOptionGroups(autoResolved: string): TzOptionGroup[] {
  return [
    {
      label: "Automatic",
      options: [
        { value: TZ_AUTO, label: `Auto · follow my browser (${autoResolved})` },
        { value: TZ_UTC, label: "UTC (no conversion)" },
      ],
    },
    {
      label: "Americas",
      options: [
        { value: "America/Los_Angeles", label: "Los Angeles (Pacific)" },
        { value: "America/Denver", label: "Denver (Mountain)" },
        { value: "America/Chicago", label: "Chicago (Central)" },
        { value: "America/New_York", label: "New York (Eastern)" },
        { value: "America/Sao_Paulo", label: "São Paulo" },
      ],
    },
    {
      label: "Europe / Africa",
      options: [
        { value: "Europe/London", label: "London" },
        { value: "Europe/Berlin", label: "Berlin / Paris / Madrid" },
        { value: "Europe/Athens", label: "Athens / Helsinki" },
        { value: "Africa/Johannesburg", label: "Johannesburg" },
      ],
    },
    {
      label: "Asia / Pacific",
      options: [
        { value: "Asia/Dubai", label: "Dubai" },
        { value: "Asia/Kolkata", label: "Mumbai / Delhi" },
        { value: "Asia/Singapore", label: "Singapore" },
        { value: "Asia/Tokyo", label: "Tokyo" },
        { value: "Australia/Sydney", label: "Sydney" },
      ],
    },
  ];
}